module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moral-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/morals"
    }
  }, [_vm._v(_vm._s(_vm.$t('Moral')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/moral_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Moral List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Moral Edit')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Moral Edit')))]), (_vm.searchCallbackFlag || !_vm.savingFlag) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("タイトル")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moral.moral_title),
      expression: "moral.moral_title"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.moral_title
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": _vm._s(_vm.moral.moral_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.moral.moral_title = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.moral_title),
      expression: "!validation.moral_title"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("回答対象ユーザー")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allCheck),
      expression: "allCheck"
    }],
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allCheck) ? _vm._i(_vm.allCheck, null) > -1 : (_vm.allCheck)
    },
    on: {
      "click": [function($event) {
        var $$a = _vm.allCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.allCheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allCheck = $$c
        }
      }, _vm.targetAllCheck]
    }
  }), _c('label', [_vm._v("全選択")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.usertypeGetCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, _vm._l((_vm.usertypes), function(usertype, index) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.usertypeIds),
        expression: "usertypeIds"
      }],
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": usertype.id,
        "checked": Array.isArray(_vm.usertypeIds) ? _vm._i(_vm.usertypeIds, usertype.id) > -1 : (_vm.usertypeIds)
      },
      on: {
        "click": function($event) {
          var $$a = _vm.usertypeIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = usertype.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.usertypeIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.usertypeIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.usertypeIds = $$c
          }
        }
      }
    }), _c('label', [_vm._v(_vm._s(usertype.attributes['user-type-name']))])])
  })) : _vm._e(), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.usertypeIds),
      expression: "!validation.usertypeIds"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.check')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("公開範囲ユーザー")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moral.reference_authority),
      expression: "moral.reference_authority"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.reference_authority
    },
    on: {
      "change": function($event) {
        _vm.moral.reference_authority = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("システム管理者")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("店舗管理者")])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.reference_authority),
      expression: "!validation.reference_authority"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("閲覧公開年月日")]), _c('div', {
    staticClass: "form-inline col-sm-10"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moral.moral_start_date),
      expression: "moral.moral_start_date"
    }],
    attrs: {
      "placeholder": "公開開始日"
    },
    domProps: {
      "value": (_vm.moral.moral_start_date)
    },
    on: {
      "input": function($event) {
        _vm.moral.moral_start_date = $event
      }
    }
  }), _c('span', {
    staticClass: "form-inline"
  }, [_vm._v(" 〜 ")]), _c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moral.moral_end_date),
      expression: "moral.moral_end_date"
    }],
    attrs: {
      "placeholder": "公開終了日"
    },
    domProps: {
      "value": (_vm.moral.moral_end_date)
    },
    on: {
      "input": function($event) {
        _vm.moral.moral_end_date = $event
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.moral_start_end),
      expression: "!validation.moral_start_end"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.after_today')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.moral_start_end_range),
      expression: "!validation.moral_start_end_range"
    }],
    staticClass: "validation-msg"
  }, [_vm._v("終了日が開始日より前です。")])], 1)]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("確認内容")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.check_content.length),
      expression: "!validation.check_content.length"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _vm._l((_vm.localMorals), function(localMoral, index) {
    return _c('div', {
      staticClass: "row margin-top"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("サブタイトル" + _vm._s(index + 1))]), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (localMoral.sub_title),
        expression: "localMoral.sub_title"
      }],
      staticClass: "form-control",
      class: {
        required: !_vm.validation.sub_title[index]
      },
      attrs: {
        "type": "text",
        "maxlength": "20"
      },
      domProps: {
        "value": _vm._s(localMoral.sub_title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          localMoral.sub_title = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.sub_title[index]),
        expression: "!validation.sub_title[index]"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("モラル行動指針" + _vm._s(index + 1))]), _c('div', {
      staticClass: "col-sm-5"
    }, [(_vm.guidelineGetCallbackFlag) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (localMoral.guideline_id),
        expression: "localMoral.guideline_id"
      }],
      staticClass: "form-control",
      class: {
        required: !_vm.validation.guideline_id[index]
      },
      on: {
        "change": function($event) {
          localMoral.guideline_id = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        }
      }
    }, [_c('option'), _vm._l((_vm.guidelines), function(guideline) {
      return _c('option', {
        domProps: {
          "value": guideline.id
        }
      }, [_vm._v(_vm._s(guideline.attributes['guideline-content']))])
    })], 2) : _vm._e(), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.guideline_id[index]),
        expression: "!validation.guideline_id[index]"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
      staticClass: "row margin-top"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("確認" + _vm._s(index + 1))]), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (localMoral.check_content),
        expression: "localMoral.check_content"
      }],
      staticClass: "form-control",
      class: {
        required: !_vm.validation.check_content[index]
      },
      attrs: {
        "type": "text",
        "maxlength": "255",
        "rows": "9"
      },
      domProps: {
        "value": _vm._s(localMoral.check_content)
      },
      on: {
        "keyup": function($event) {
          _vm.contentCounter(index)
        },
        "touchend": function($event) {
          _vm.contentCounter(index)
        },
        "change": function($event) {
          _vm.contentCounter(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          localMoral.check_content = $event.target.value
        }
      }
    }), _c('p', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(localMoral.check_content_count) + "/255")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.check_content[index]),
        expression: "!validation.check_content[index]"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('div', {
      staticClass: "col-sm-2"
    }, [(localMoral.check_image) ? _c('div', {
      staticClass: "box"
    }, [_c('img', {
      staticClass: "img-rounded",
      staticStyle: {
        "width": "200px",
        "height": "200px"
      },
      attrs: {
        "src": localMoral.check_image
      },
      on: {
        "click": function($event) {
          _vm.onClickImageModalShow(index)
        }
      }
    })]) : _vm._e(), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!localMoral.check_image),
        expression: "!localMoral.check_image"
      }],
      staticClass: "profile fa fa-file-image-o"
    }), _c('a', {
      staticClass: "btn btn-default",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#image_upload_modal"
      },
      on: {
        "click": function($event) {
          _vm.indexSave(index)
        }
      }
    }, [_c('span', [_vm._v("画像登録")])]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.uploadError),
        expression: "uploadError"
      }],
      staticClass: "validation-msg"
    }, [_vm._v("画像のアップロードに失敗しています")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.check_image[index]),
        expression: "!validation.check_image[index]"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
      staticClass: "row margin-top text-left"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("はい回答補足" + _vm._s(index + 1))]), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (localMoral.yes_answer_add),
        expression: "localMoral.yes_answer_add"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "type": "text",
        "maxlength": "20",
        "rows": "3"
      },
      domProps: {
        "value": _vm._s(localMoral.yes_answer_add)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          localMoral.yes_answer_add = $event.target.value
        }
      }
    })]), _c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("いいえ回答補足" + _vm._s(index + 1))]), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (localMoral.no_answer_add),
        expression: "localMoral.no_answer_add"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "type": "text",
        "maxlength": "20",
        "rows": "3"
      },
      domProps: {
        "value": _vm._s(localMoral.no_answer_add)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          localMoral.no_answer_add = $event.target.value
        }
      }
    })])]), _c('div', {
      staticClass: "row margin-top text-right"
    }, [_c('div', {
      staticClass: "col-sm-5"
    }), _c('div', {
      staticClass: "col-sm-7 text-right"
    }, [_c('a', {
      staticClass: "btn btn-default",
      staticStyle: {
        "margin-right": "5px"
      },
      on: {
        "click": function($event) {
          _vm.addMoral(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    }), _c('span', [_vm._v("確認追加")])]), _c('a', {
      staticClass: "btn btn-danger",
      staticStyle: {
        "margin-right": "5px"
      },
      on: {
        "click": function($event) {
          _vm.deleteMoral(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-square"
    }), _c('span', [_vm._v("確認削除")])])])])])
  }), (_vm.localMorals.length == 0) ? _c('div', {
    staticClass: "row margintop"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }), _c('div', {
    staticClass: "col-sm-7 text-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addMoral()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _c('span', [_vm._v("確認追加")])]), _c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.deleteMoral()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus-square"
  }), _c('span', [_vm._v("確認削除")])])])]) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])], 2) : (!_vm.searchCallbackFlag && !_vm.savingFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])]) : (_vm.savingFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("保存中...")])])]) : _vm._e(), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "image_upload_modal",
      "role": "dialog",
      "aria-labelledby": "imageUploadModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "id": "image_upload_section"
    }
  }, [_c('div', {
    staticClass: "drop-uploader text-center",
    attrs: {
      "id": "drop"
    },
    on: {
      "dragover": function($event) {
        _vm.onDragOver(_vm.saveIndex, arguments[0])
      },
      "drop": function($event) {
        _vm.onDrop(_vm.saveIndex, arguments[0])
      }
    }
  }, [_c('p', [_vm._v("ここに画像をドラッグアンドドロップしてください。")]), _c('i', {
    staticClass: "fa fa-upload"
  })]), (_vm.view) ? _c('input', {
    attrs: {
      "type": "file",
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange(_vm.saveIndex, arguments[0])
      }
    }
  }) : _vm._e()]), (_vm.uploadSuccess && _vm.upFlg) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Image Upload Successful')))])]) : _vm._e(), (_vm.uploadError && _vm.upFlg) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Image Upload Error')))])]) : _vm._e()]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "imageUploadModalLabel"
    }
  }, [_vm._v("画像登録")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce445f02!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/moral-edit.pug
// module id = 889
// module chunks = 1